import { Component, OnInit } from '@angular/core';
import { trigger, transition, animate, style } from '@angular/animations'
import { HttpClient } from "@angular/common/http";
import { SafePipe } from "app/cp/shared/pipes/safe.pipe"

@Component( {
    selector: 'cp-seattle',
    templateUrl: './seattle.component.html',
    styleUrls: [ './seattle.component.scss' ],
    animations: [
        trigger( 'slideInOut', [
            transition( ':enter', [
                style( { transform: 'translateX(-100%)' } ),
                animate( '200ms ease-in', style( { transform: 'translateX(0%)' } ) )
            ] ),
            transition( ':leave', [
                animate( '200ms ease-in', style( { transform: 'translateX(-100%)' } ) )
            ] )
        ] )
    ]
} )
export class SeattleComponent implements OnInit {

    public downloadOptions: boolean = false;
    public downloadDevOptions: boolean = false;
    public device: any;

    protected _http: any;
    mobileAppUrls: any = [];

    constructor( _http: HttpClient ) {
        this._http = _http;
        this._http.get( 'assets/mobileAppUrls.json' ).subscribe( data => {
            this.mobileAppUrls = data;
        } );
    }

    ngOnInit() {
        if ( /Android|webOS|iPhone|iPad|iPod|MacIntel|BlackBerry/i.test( navigator.userAgent ) ||
            (/Android|webOS|iPhone|iPad|iPod|MacIntel|BlackBerry/i.test( navigator.platform )) ) {

            this.device = navigator.platform;
        }
        //this.downloadApp();
    }

    viewDownloadOptions() {
        this.downloadOptions = ! this.downloadOptions;
    }

    viewDownloadOptionsDev() {
        this.downloadDevOptions = ! this.downloadDevOptions;
    }

    downloadApp() {
        if ( this.device == 'iPhone' ) {
            //alert('iPhone');
        } else if ( this.device == 'Android' ) {
            //alert('Android');
        } else {
            //alert('Desktop');
        }
    }

}
